import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useReactToPrint } from 'react-to-print'
import { Button, Modal } from 'reactstrap'
import { MODAL_TYPES } from '../../../common/constants'
import { hideModal } from '../../../store/modal'
import { resetTableCheckbox } from '../../../store/table'
import PrintContent from './PrintContent'
import { PropertyPrintFormModalProps } from './types'

const PropertyPrintFormModal = (props: PropertyPrintFormModalProps) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const contentRef = useRef<HTMLDivElement>(null)

    const { isOpen } = props
    const { PROPERTY_PRINT_FORM_MODAL } = MODAL_TYPES

    const handlePrint = useReactToPrint({
        contentRef,
        pageStyle: `
            @page {
                margin: 10px;
            }
            @media print {
                .page-break-before { page-break-before: always; }
                .page-break-after { page-break-after: always; }
            }
        `,
    })

    const handleClose = () => {
        const modalPayload = {
            modalType: PROPERTY_PRINT_FORM_MODAL,
        }

        dispatch(hideModal(modalPayload))
        dispatch(resetTableCheckbox(true))
    }

    return (
        <Modal isOpen={isOpen} centered size="lg">
            <div className="p-3">
                <div className="d-flex justify-content-end align-items-center mb-2">
                    <Button type="submit" color="send" className="btn-label me-2" onClick={() => handlePrint()}>
                        <i className="mdi mdi-printer-outline align-bottom label-icon align-middle fs-16 me-2"></i>
                        {t('app.common.print')}
                    </Button>
                    <Button type="button" color="primary" className="btn-label" data-bs-dismiss="modal" onClick={handleClose}>
                        <i className="mdi mdi-close label-icon align-middle fs-16"></i>
                        {t('button.cancel')}
                    </Button>
                </div>
                <PrintContent ref={contentRef} />
            </div>
        </Modal>
    )
}

export default PropertyPrintFormModal
